import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'trustStyleUrl'
})
export class TrustStyleUrlPipe implements PipeTransform {

  constructor(
    private sanitizer: DomSanitizer
  ) { }

  transform(value: string) {
    return this.sanitizer.bypassSecurityTrustStyle('url("' + value + '")');
  }
}
